import { createTheme } from "@mui/material";
import {
  indigo,
  teal,
  grey,
  blue,
  orange,
  red,
  brown,
} from "@mui/material/colors";

const theme = createTheme({
  palette: {
    nav: {
      main: "#43215d",
    },
    list: {
      selected: { main: indigo[200], accent: indigo[50] },
      notSelected: {
        main: grey[100],
        accent: grey[50],
      },
    },
    background: {
      main: grey[100],
      focus: blue[100],
    },
    primary: {
      main: orange[800],
    },
    secondary: {
      main: teal[600],
    },
    warning: {
      main: red[500],
    },
    specialHeadingText: {
      main: brown[800],
    },
    input: {
      color: "white",
    },
  },
  typography: {
    h1: {
      fontSize: "2rem",
    },
    h2: {
      fontSize: "1.75rem",
    },
    h3: {
      fontSize: "1.5rem",
    },
    h4: {
      fontSize: "1.35rem",
    },
    h5: {
      fontSize: "1.1rem",
      lineHeight: "1",
      fontWeight: "550",
    },
    h6: {
      fontSize: "1.1rem",
      lineHeight: "1",
    },
    body1: {
      lineHeight: "1.2",
    },
  },
  overrides: {
    MUIRichTextEditor: {
      root: {
        border: "1px solid lightgrey",
        borderRadius: "4px",
      },
      editor: {
        padding: "2rem",
        overflow: "auto",
      },
      placeHolder: {
        paddingLeft: "2rem",
        color: "grey",
      },
      anchorLink: {
        color: "#FFEB3B",
        textDecoration: "underline",
      },
    },
  },
});

export default theme;
